import * as service from './suppliers.service'
export default {
  data() {

    return {
      compliance_columns: ['CompanyName', 'MainNumber', 'FirstName', 'CellNumber', 'PrimaryEmail', 'Actions'],
      optionstable: {
        headings: {
          FirstName: 'Contact Name',
          LastName: 'Last Name',
          CompanyName: 'Company Name',
          MainNumber: 'Company Contact Number',
          CellNumber: 'Contact Number',
          PrimaryEmail: 'Email Address',

          Actions: ''
        },
        labelPosition: 'top',
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],

        texts: {
          filterPlaceholder: 'Search...',
          limit: 'Rows per page:',
          noResults: 'No matching records',
        }
      },

      supplier: {
        CompanyName: '',
        WebAddress: '',
        Address1: '',
        City: '',
        State: '',
        ZipCode: '',
        MainNumber: '',
        MainFaxNumber: '',
        PaymentCompanyName: '',
        PaymentAddress1: '',
        PaymentCity: '',
        PaymentState: '',
        PaymentZipCode: '',
        SupplierContacts: [{
          FirstName: '',
          LastName: '',
          Address1: '',
          City: '',
          State: '',
          ZipCode: '',
          SupplierNotes: '',
          CellNumber: '',
          HomeNumber: '',
          PrimaryEmail: '',
          AlternativeEmail: '',
          EmployeeNotes: '',

        }],

      },
      copyToPayment: false,
      addComplianceCopy: {},
      rules: {

        CompanyName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        PaymentCompanyName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        MainNumber: [

          /*  {required: true, message: 'This field is required'},
           // {min: 1, max: 50, message: 'Length should be 1 to 50'},
           { type: 'number', message: 'This Field must be a number'}*/

        ],

      },
      Suppliers: [],

      modalTitle: '',
      locationId: 25,
      isediting: false,
      isaddding: false,
      isAddingOrEditing: "" //FG - FOOF - After Cert - First Release Security(7)

    }
  },
  mounted() {

    this.GetAllSuppliers()


  },

  methods: {
    showFtab() {
      $('#fli').addClass('active')
      $('#sli').removeClass('active')
      $('#profile-tab-1').show()
      $('#profile-tab-2').hide()
    },

    showStab() {
      this.$refs['addCompliance'].validate((valid) => {
        if (valid) {
          $('#sli').addClass('active')
          $('#fli').removeClass('active')
          $('#profile-tab-2').show()
          $('#profile-tab-1').hide()
        }
      })
    },
    CopyTo() {

      if (this.copyToPayment) {
        this.supplier.PaymentCompanyName = this.supplier.CompanyName
        this.supplier.PaymentAddress1 = this.supplier.Address1
        this.supplier.PaymentCity = this.supplier.City
        this.supplier.PaymentState = this.supplier.State
        this.supplier.PaymentZipCode = this.supplier.ZipCode

      } else {

        this.supplier.PaymentCompanyName = ""
        this.supplier.PaymentAddress1 = ""
        this.supplier.PaymentCity = ""
        this.supplier.PaymentState = ""
        this.supplier.PaymentZipCode = ""

      }


    },
    addCompliancevit() {
      this.isaddding = true
      this.isAddingOrEditing = "A"
      this.supplier = {
        CompanyName: '',
        WebAddress: '',
        Address1: '',
        City: '',
        State: '',
        ZipCode: '',
        MainNumber: '',
        MainFaxNumber: '',
        PaymentCompanyName: '',
        PaymentAddress1: '',
        PaymentCity: '',
        PaymentState: '',
        PaymentZipCode: '',
        SupplierContacts: [{
          FirstName: '',
          LastName: '',
          Address1: '',
          City: '',
          State: '',
          ZipCode: '',
          SupplierNotes: '',
          CellNumber: '',
          HomeNumber: '',
          PrimaryEmail: '',
          AlternativeEmail: '',
          EmployeeNotes: '',

        }]
      }

      this.copyToPayment = false
    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
      this.isAddingOrEditing = ""
    },


    GetAllSuppliers() {
      let context = this
      loader.startLoader()
      service.GetAllSuppliers().then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.Suppliers = []
          loader.stopLoader()
          return;
        }

        if (response && response != null) {
          context.Suppliers = response
          tooltip.startTooltip(50)
        } else {

          context.Suppliers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetMemberDetails(id) {
      let context = this
      loader.startLoader()
      service.GetMemberDetails(id).then(function (response) {

        if (response && response != null) {
          context.addAccount = response
        }


        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.SupplierId
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + data.row.CompanyName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteSupplierRow.bind(null,ID))
    },
    deleteSupplierRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteSupplier(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
          loader.stopLoader()
          return;
        }

        context.GetAllSuppliers()
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    
    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.Id

      let context = this
      context.EditableColID = ID;
      this.supplier = data.row

      context.isediting = true
      context.isAddingOrEditing = "E"

    },


    AddSupplier(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          // context.addAccount['LocationId'] = context.locationId

          service.AddSupplier(context.supplier).then(function (response) {
            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
              loader.stopLoader()
              return;
            }
            loader.stopLoader()

            var a = context.supplier;
            context.$notify({
              title: 'Success',
              message: 'Supplier details Created',
              type: 'success'
            })
            context.GetAllSuppliers()
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'SUPPLIERS - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    UpdateSupplier(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          //context.addAccount['LocationId'] = context.locationId


          // context.addCompliance['Id'] =
          service.UpdateSupplier(context.supplier).then(function (response) {
            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
              loader.stopLoader()
              return;
            }
            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Supplier details Updated',
              type: 'success'
            })
            context.GetAllSuppliers()
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'SUPPLIERS -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/Administration/suppliers.controller.js